import { render } from "./ParticipantsView.vue?vue&type=template&id=7a374287&scoped=true"
import script from "./ParticipantsView.vue?vue&type=script&lang=js"
export * from "./ParticipantsView.vue?vue&type=script&lang=js"

import "./ParticipantsView.vue?vue&type=style&index=0&id=7a374287&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a374287"]])

export default __exports__